import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import { ScContentTemplate } from '../../models';

@Injectable()
export class ScTemplateService {
  private _footerSubject: BehaviorSubject<ScContentTemplate> = new BehaviorSubject(null);

  private _headerSubject: BehaviorSubject<ScContentTemplate> = new BehaviorSubject(null);

  constructor() {}

  public setFooter(content: ScContentTemplate): void {
    this._footerSubject.next(content);
  }

  public getFooter(): Observable<ScContentTemplate> {
    return this._footerSubject.asObservable().pipe(filter(tem => !!tem));
  }

  public setHeader(content: ScContentTemplate): void {
    this._headerSubject.next(content);
  }

  public getHeader(): Observable<ScContentTemplate> {
    return this._headerSubject.asObservable().pipe(filter(tem => !!tem));
  }
}
